import React from 'react';

export const RollerFrontRoll = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g
        clipPath="url(#prefix__b)"
        stroke="#233762"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      >
        <path fill="#fff" strokeWidth={2} d="M31.6 57.4l72.2-12.1" />
        <path
          d="M103.8 20.8L31.6 33.2c12.6 1.3 8.7 18.5 9.8 66.5l60.9-10 1.5-68.9z"
          fill="#8291ae"
          strokeWidth={2}
        />
        <ellipse
          cx={31.6}
          cy={45.3}
          rx={8.7}
          ry={12.1}
          fill="#fff"
          strokeWidth={2}
        />
        <ellipse
          cx={27.9}
          cy={45.3}
          rx={4.4}
          ry={6}
          fill="#fff"
          strokeWidth={1.589}
        />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
      <path
        d="M17 40.8c-1.3-8.6 5.3-16.3 13.8-16.9 8.8-.6 15.7 5.6 19.7 12.9-1.9-.9-3.9-1.9-5.9-2.7-2-.8-3.2 2.4-1.2 3.1 3.2 1.1 6.6 2.3 9.7 3.8.9.4 1.7-.3 1.9-1.1.7-3.3 1-6.6.8-9.9 0-.4-.4-.9-.8-1-.3-.1-.4-.2-.7-.1-.1 0-.2.1-.2.1-.4.1-.7.6-.8 1-.2 1.8-.4 3.5-.6 5.3-3.6-9.3-12.4-16.1-22.9-14.9-9.8 1.1-18 11-14 20.8.2.7 1.4.3 1.2-.4z"
        fill="#11768b"
      />
    </svg>
  );
};
